import { deserialize } from 'cerialize'
import { UserShortModel } from 'Pages/auth'
import { GosbModel, SectorModel, TerritorialbankModel } from 'Pages/referenceBooks'

export class ChannelStructureModel {
	@deserialize public head_sector: UserShortModel
	@deserialize public reg_manager: UserShortModel
	@deserialize public territorial_bank: TerritorialbankModel
	@deserialize public terr_manager: UserShortModel
	@deserialize public gosb: GosbModel
	@deserialize public sector: SectorModel
	@deserialize public head_governance: UserShortModel
	@deserialize public senior_manager: UserShortModel

	public get id(): number {
		return this?.reg_manager?.id
	}
	public get head_sector_name(): string {
		return this?.head_sector?.name
	}
	public get reg_manager_name(): string {
		return this?.reg_manager?.name
	}
	public get terr_manager_name(): string | null {
		return this?.terr_manager?.name
	}
	public get gosb_name(): string {
		return this?.gosb?.name
	}
	public get sector_name(): string {
		return this?.sector?.name
	}
	public get head_governance_name(): string {
		return this?.head_governance?.name
	}
	public get senior_manager_name(): string {
		return this?.senior_manager?.name
	}
	public get gosb_category_name(): string | number {
		return this?.gosb?.category
	}
}
